import "./SyntheticUserEditPassword.css"

import React, {useEffect} from 'react';

import {useParams} from "react-router-dom";
import api from "../../utils/api";
import {Navigate} from "react-router-dom";
import {toast} from "react-toastify";
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import DefaultButton, {SecondaryButton} from "../../components/Buttons/DefaultButton/DefaultButton";
import {Input} from "react-aria-components";
import {LabeledSection, LabeledTextField} from "../../components/Fields/LabeledTextField";
import {LuKey} from "react-icons/lu";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout";

function SyntheticUserEditPassword() {
    const {id} = useParams()
    const [user, setUser] = React.useState(null)
    const [password, setPassword] = React.useState("")
    const [password2, setPassword2] = React.useState("")
    const [redirect, setRedirect] = React.useState(null)

    useEffect(() => {
        api.getSyntheticUser(id).then(data => {
            setUser(data)
        })
    }, [id]);

    function save() {
        if (password !== password2) {
            toast.warn("Passwords do not match")
            return
        }
        api.updateSyntheticUserPassword(id, password).then(() => {
            setRedirect("/users")
        })
    }

    if (redirect !== null) {
        return <Navigate to={redirect}/>
    }

    if (user === null) {
        return <LoadingLayout />
    }

    const content = <div className="SyntheticUserEditPassword">
    <LabeledSection label="Password" icon={<LuKey/>} className="SyntheticUserEditPassword">
            <LabeledTextField
                label="Password"
                value={password}
                placeholder="New Password"
                onChange={(e) => setPassword(e.target.value)}
                name="password1"
                errorLoc={[]}
                inputType={"password"}
                hiddenLabel={false}
            />
            <LabeledTextField
                label="Confirm Password"
                value={password2}
                placeholder="Repeat Password"
                onChange={(e) => setPassword2(e.target.value)}
                name="password2"
                errorLoc={[]}
                inputType={"password"}
                hiddenLabel={false}
            />
        </LabeledSection>

        <div className="save-row">
            <SecondaryButton
                className="cancel-button"
                text="Cancel"
                href="/users"
            />
            <DefaultButton text="Save" onPress={save} oneClick />
        </div>
    </div>

    return <FullWidthLayout
        title={`Change Password: ${user.name}`}
        mainContent={content}
    />
}

export default SyntheticUserEditPassword;